import { render } from "./AppSalesPage.vue?vue&type=template&id=2cf7df0c&ts=true"
import script from "./AppSalesPage.vue?vue&type=script&lang=ts"
export * from "./AppSalesPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__